import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  cargando = new BehaviorSubject<boolean>(false);
  private contadorSolicitudes = 0;

  constructor() {}

  mostrar = (): void => {
    this.contadorSolicitudes++;
    if (this.contadorSolicitudes === 1) {
      queueMicrotask(() => this.cargando.next(true));
    }
  };

  ocultar = (): void => {
    this.contadorSolicitudes = Math.max(0, this.contadorSolicitudes - 1);
    if (this.contadorSolicitudes === 0) {
      queueMicrotask(() => this.cargando.next(false));
    }
  };

  forzarCierre = (): void => {
    this.contadorSolicitudes = 0;
    queueMicrotask(() => this.cargando.next(false));
  };

  estaActivo = (): boolean => {
    return this.cargando.value;
  };

  permitirCierreModal = (): boolean => {
    return !this.estaActivo();
  };
}
